module.exports = __webpack_public_path__ + "static/media/about7.bb347b57.webp";